const prodRecall = () => import("@/pages/reg/regProdRecall/regProdRecall.vue");
const inquiry = () => import("@/pages/reg/regInquiry/regInquiryDetail.vue");

const compDetail = () => import("@/pages/reg/comp/compDetail");

export default [
  {
    path: "/regInfo/prodRecall",
    name: "prodRecall",
    component: prodRecall,
    meta: {
      title: "产品召回",
      noCache: true,
      affix: true,
      path: ["生产监管", "产品召回"]
    }
  },
  {
    path: "/regInfo/inquiry",
    name: "inquiry",
    component: inquiry,
    meta: {
      title: "创建质询",
      noCache: true,
      affix: true,
      path: ["生产监管", "创建质询"]
    }
  },
  {
    path: "/regInfo/compDetail",
    name: "compDetail",
    component: compDetail,
    meta: {
      title: "企业生产监管",
      noCache: true,
      affix: true,
      path: ["生产监管", "企业生产监管"]
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/regInfo.js